import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, Panel } from "@/pages/admin/shared";

const REASONS = {
  duplicate: ["Duplicate vote", "bg-maroon/10 text-maroon"],
  device_duplicate: ["Same device, new OTP", "bg-saffron/15 text-saffron"],
  rate_limited: ["IP rate limit", "bg-navy/10 text-navy"],
  changes_exhausted: ["No vote changes left", "bg-forest/10 text-forest"],
};

export default function Fraud() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    const load = () => api.get("/admin/fraud").then((r) => setRows(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, []);

  return (
    <div data-testid="admin-fraud">
      <PageHeader title="Fraud log" sub={`${rows.length} rejected attempts (latest 500)`} />
      <Panel className="overflow-x-auto p-0">
        <table className="w-full min-w-[560px] text-left text-sm">
          <thead className="bg-ivory-dark text-xs uppercase tracking-wider text-ink-muted">
            <tr><th className="px-4 py-3">Time</th><th className="px-4 py-3">Reason</th><th className="px-4 py-3">Category</th><th className="px-4 py-3">Voter hash</th><th className="px-4 py-3">IP hash</th></tr>
          </thead>
          <tbody>
            {rows.map((r) => {
              const [label, cls] = REASONS[r.reason] || [r.reason, "bg-gold/20"];
              return (
                <tr key={r.id} data-testid={`fraud-row-${r.id}`} className="border-t border-gold/20">
                  <td className="whitespace-nowrap px-4 py-3 tabular-nums">{new Date(r.created_at + (r.created_at.endsWith("Z") || r.created_at.includes("+") ? "" : "Z")).toLocaleString()}</td>
                  <td className="px-4 py-3"><span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${cls}`}>{label}</span></td>
                  <td className="px-4 py-3">{r.category}</td>
                  <td className="px-4 py-3 font-mono text-xs">{r.voter_hash.slice(0, 12)}…</td>
                  <td className="px-4 py-3 font-mono text-xs">{r.ip_hash.slice(0, 10)}…</td>
                </tr>
              );
            })}
            {!rows.length && <tr><td colSpan={5} className="px-4 py-10 text-center text-ink-muted" data-testid="fraud-empty">No rejected attempts yet.</td></tr>}
          </tbody>
        </table>
      </Panel>
    </div>
  );
}
